function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M44 1H0",
  stroke: "#fff"
});

function SvgMinusSymbol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 2,
    viewBox: "0 0 44 2",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iMiIgdmlld0JveD0iMCAwIDQ0IDIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik00NCAxTC0xLjQzMDUxZS0wNiAwLjk5OTk5OCIgc3Ryb2tlPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgMinusSymbol as ReactComponent };